import { wrapper, createApiClient, Result, ApiError } from "../base";
import NavigationGroupDO = App.Data.NavigationGroupDO;
import {
	LaravelPaginatedCollection,
	PaginatedCollection,
} from "@/types/collections";

const basePath = `notifications`;
const baseClient = createApiClient();

export default class {
	getAvailableNotificationTypes(): Promise<
		Result<App.Data.NotificationTypeDO[], ApiError>
	> {
		return wrapper(
			baseClient.get(`${basePath}/get-available-notification-types`)
		);
	}
	getNotificationFilterTabs(): Promise<
		Result<App.Data.NotificationTypeDO[], ApiError>
	> {
		return wrapper(baseClient.get(`${basePath}/get-notification-filter-tabs`));
	}
	getNotifications(
		type: string,
		page: number
	): Promise<
		Result<LaravelPaginatedCollection<App.Data.NotificationTypeDO>, ApiError>
	> {
		return wrapper(
			baseClient.get(`${basePath}/get-notifications?type=${type}&page=${page}`)
		);
	}
}
